/* ---------- plate, poured: the ink given to the scroll ---------- */
  function wirePlatePour() {
    /* the landing alone: every other page was paying three megabytes for a
       stage it never shows */
    if (document.body.dataset.page !== 'landing') return;
    const phone = isPhone();
    /* the hand's stage (assets/mobile.css) pours on every touch screen; between
       it and the desk a hovering window keeps its landed still */
    const touch = isTouch();
    if (param('shot') || REDUCE || (!touch && !isDesktop())) return;

    /* the frames are 1600 wide and the phone asks the CDN for 800, but a tablet
       takes the source because a narrower cut costs more bytes (frame-00:
       103,287 at width 1200 against 88,718 bare) */
    const SRC_PX = phone ? 800 : 1600;

    const N = 32, DIR = asset('shared/assets/brand/ink-seq-pour/');
    let LEAD = 0.12, SPAN = 0.78;
    /* the hand's stage locks at cover 64% (mobile.css), so the pour must land
       before that or the last frames are never reached */
    if (touch) { LEAD = 0.08; SPAN = 0.58; }

    let frames = [], dead = false, left = N;
    const canvas = document.createElement('canvas');
    canvas.className = 'plate-pour';
    const ctx = canvas.getContext('2d');
    let stage = null, host = null;
    let lastPainted = -1, lastY = null;
    /* the still ground's own crop, read from the stylesheet in arm() */
    let AX = 0.5, AY = 0.64;

    function fit() {
      const dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      let w = Math.round(host.clientWidth * dpr), h = Math.round(host.clientHeight * dpr);
      /* never wider than the frames: past the source width the backing is
         interpolation composited thirty-two times over */
      if (w > SRC_PX) { h = Math.round(h * SRC_PX / w); w = SRC_PX; }
      if (!w || !h || (canvas.width === w && canvas.height === h)) return;
      canvas.width = w; canvas.height = h;
      lastPainted = -1;
    }

    function cover(img) {
      const s = Math.max(canvas.width / img.naturalWidth, canvas.height / img.naturalHeight);
      const dw = img.naturalWidth * s, dh = img.naturalHeight * s;
      ctx.drawImage(img, (canvas.width - dw) * AX, (canvas.height - dh) * AY, dw, dh);
    }

    /* a crossfade between frames, so thirty-two stills read continuous */
    function paint(at) {
      at = Math.max(0, Math.min(N - 1, at));
      if (Math.abs(at - lastPainted) < 1 / 64) return;
      lastPainted = at;
      const i = Math.floor(at), f = at - i;
      cover(frames[i]);
      if (f > 0.004 && i < N - 1) {
        ctx.globalAlpha = f;
        cover(frames[i + 1]);
        ctx.globalAlpha = 1;
      }
    }

    /* the latch's own arithmetic (assets/plate.js): 0 as the stage's top touches
       the window's foot, landed at SPAN */
    function poured() {
      const r = stage.getBoundingClientRect();
      const vh = window.innerHeight;
      const covered = (vh - r.top) / (r.height + vh);
      return Math.min(1, Math.max(0, (covered - LEAD) / (SPAN - LEAD))) * (N - 1);
    }

    function arm() {
      stage = document.querySelector('.plate-stage');
      host = stage && stage.querySelector('.plate-img');
      if (!host) return;
      const pos = getComputedStyle(host).backgroundPosition.split(' ');
      if (pos.length === 2 && /%$/.test(pos[0]) && /%$/.test(pos[1])) {
        AX = parseFloat(pos[0]) / 100; AY = parseFloat(pos[1]) / 100;
      }
      host.appendChild(canvas);
      document.body.dataset.pour = '1';
      fit();
      paint(poured());
      window.addEventListener('resize', function () {
        fit();
        lastY = null;
      });
      /* read in the frame, not from scroll events: Lenis drives the scroll itself */
      (function frame() {
        requestAnimationFrame(frame);
        const y = window.scrollY;
        if (y === lastY) return;
        lastY = y;
        paint(poured());
      })();
    }

    /* whole or not at all, the menu's own rule */
    function one() {
      if (--left || dead) return;
      arm();
    }
    function miss() {
      dead = true;
      if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
    }
    /* only the phone asks the CDN for a narrower frame: the desk already
       upscales the 1600 source, so there is nothing there to recover; the phone
       gives back more than half the file (measured: 88,718 bytes bare against
       49,914 at width 800) */
    const SRC_WIDTH = phone ? '&width=' + SRC_PX : '';

    function fetchFrames() {
      for (let i = 0; i < N; i++) {
        const img = new Image();
        img.onload = one;
        img.onerror = miss;
        img.src = DIR + 'frame-' + String(i).padStart(2, '0') + '.jpg?v=2' + SRC_WIDTH;
        frames.push(img);
      }
    }

    /* fetched on the first scroll, never before: a reader who lands and leaves
       was paying three megabytes for a stage a screen down. Not by approach:
       .plate-stage begins exactly on the fold, so an IntersectionObserver with
       any non-negative rootMargin fires before the reader has moved. A slow set
       leaves the plate on its landed still frame; late costs the pour, never
       the page. */
    window.addEventListener('scroll', fetchFrames, { once: true, passive: true });
  }
